import { createRouter, createWebHistory } from 'vue-router'
import { setupRouterGuard } from '@/router/guard.config'
import { routerComm } from '@/router/routes/COMM.router'
import { routerDlds } from '@/router/routes/DLDS.router'
import { routerDllg } from '@/router/routes/DLLG.router'
import { routerDlmr } from '@/router/routes/DLMR.router'
import { routerDlmp } from '@/router/routes/DLMP.router'
import { routerExternal } from '@/router/routes/EXTERNAL.router'
import { routerExtra } from '@/router/routes/EXTRA.router'

const routes = [
  ...routerComm,
  ...routerDlds,
  ...routerDllg,
  ...routerDlmr,
  ...routerDlmp,
  ...routerExternal,
  ...routerExtra,
  {
    path: '/',
    redirect: '/dllg/DLLG-01-V101',
    meta: {
      title: '로그인',
      code: 'DLLG-01-V101',
      tabName: '로그인'
    }
  },
  {
    path: '/app',
    redirect: '/external/DWLOAD-APP',
    meta: {
      title: '앱설치(수퍼운영시스템)',
      code: 'DWLOAD-APP',
      tabName: '앱설치(수퍼운영시스템)'
    }
  },
  {
    path: '/go',
    redirect: '/external/DWLOAD-APP?type=DLY',
    meta: {
      title: '앱설치(배송관리시스템)',
      code: 'DWLOAD-APP',
      tabName: '앱설치(배송관리시스템)'
    }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      if (savedPosition) {
        resolve(savedPosition)
      } else {
        resolve({ top: 0 })
      }
    })
  }
})

setupRouterGuard(router)

export default router
